import { signal } from 'services/SignalsService'
import { activationSettings } from 'settings/custom/activations'

const existReels = [
  'ReelsEntity',
  'FoodReelsEntity',
  'ScratchReelsEntity',
  'VolcanReelsEntity',
  'ExplosionReelsEntity',
  'PiratReelsEntity',
  'CascadeEntity',
]

function getReelsName(name) {
  existReels.map((item) => {
    name === item && manageReel()
  })

  function manageReel() {
    let isActive = true

    const settings = activationSettings[name]
    settings !== undefined && Object.entries(settings).forEach(subscribe)
    function subscribe([sig, value]) {
      sig === 'default' ? isActive = value : signal.on(sig, () => isActive = value)
    }

    name = name === 'PiratReelsEntity' ? 'ReelsEntity' : name
    signal.on('ACTION:REQUEST-SPIN', () => isActive && signal.dispatch(`${name}:START`))
    signal.on('ACTION:REQUEST-RESPIN', () => isActive && signal.dispatch(`${name}:RESPIN`))
    signal.on('STATE:IN:FS-START', () => signal.dispatch(`${name}:REFRESH`, true))
    signal.on('STATE:IN:FS-END', () => signal.dispatch(`${name}:REFRESH`, false))
    signal.on('STATE:OUT:SPIN', () => {
      const spinModel = game.models.SpinModel.get()
      let freespinCount = 0

      spinModel.matrix.forEach((line) => {
        line.forEach((symbol) => {
          if(symbol === '1'){
            freespinCount++
          }
        })
      })
      if(freespinCount >= 3){
        signal.dispatch('SCATTER:EXPLOSION', false)
      }
    },
    )

  }
}

export const ReelsManager = { getReelsName }
